import type { ArchBlock } from "../arch/archContent";

type FocusContentBlocksProps = {
  blocks: ArchBlock[];
};

export default function FocusContentBlocks({
  blocks,
}: FocusContentBlocksProps) {
  return (
    <div className="flex flex-col gap-4">
      {blocks.map((block, index) => {
        if (block.type === "image") {
          return (
            <img
              key={`image-${index}`}
              src={block.src}
              alt={block.alt ?? ""}
              loading="lazy"
              decoding="async"
              width={block.width}
              height={block.height}
              className="w-full rounded-lg bg-white/5"
            />
          );
        }

        if (block.type === "text") {
          return (
            <p
              key={`text-${index}`}
              className="text-sm leading-relaxed text-white/80"
            >
              {block.body}
            </p>
          );
        }

        return (
          <dl
            key={`stats-${index}`}
            className="grid grid-cols-2 gap-x-4 gap-y-3 rounded-lg bg-white/5 p-4"
          >
            {block.items.map((item) => (
              <div key={`${item.label}-${item.value}`}>
                <dt className="text-[0.65rem] uppercase tracking-[0.2em] text-white/45">
                  {item.label}
                </dt>
                <dd className="mt-1 text-sm leading-snug text-white/85">
                  {item.value}
                </dd>
              </div>
            ))}
          </dl>
        );
      })}
    </div>
  );
}
